<template>
  <div class="my-info">
    <div class="header">
      <TopBar :title="$t('wdzl.wdzl')" />
    </div>
    <div class="content">
      <van-form>
        <van-field
          style="border-top-left-radius: 10px; border-top-right-radius: 10px"
          v-model="form.avatar"
          :name="$t('wdzl.tx')"
          :label="$t('wdzl.tx')"
          :readonly="true"
        >
        </van-field>
        <van-image
          class="avator-sty"
          round
          @click="changeAvator"
          :src="avatarUrl"
          error-icon="http://www.weopinions.com/images/photo/default.gif"
        />
        <van-icon @click="changeAvator" name="arrow" class="icon-sty" />

        <van-field
          v-model="$store.state.loginInfo.userName"
          style="
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          "
          :name="$t('wdzl.zczh')"
          :label="$t('wdzl.zczh')"
          :disabled="true"
        />
      </van-form>
      <br />
      <van-form>
        <van-field
          v-model="form.name"
          style="border-top-left-radius: 10px; border-top-right-radius: 10px"
          :name="$t('wdzl.name')"
          :label="$t('wdzl.name')"
          :disabled="formNameDisabled"
        />
        <van-field
          readonly
          :disabled="genderShow"
          clickable
          name="picker"
          :value="form.gender"
          :label="$t('wdzl.sex')"
          @click="showSexPicker = genderShow ? false : true"
        />
        <van-popup v-model="showSexPicker" position="bottom">
          <van-picker
            :title="$t('wdzl.sex')"
            :confirm-button-text="$t('wdzl.confirm')"
            :cancel-button-text="$t('wdzl.cancel')"
            show-toolbar
            :columns="columns"
            @confirm="onSexConfirm"
            @cancel="showSexPicker = false"
            value-key="label"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          :disabled="birthdayShow"
          name="datetimePicker"
          :value="form.birthday"
          :label="$t('wdzl.date')"
          :placeholder="$t('wdzl.djxzsj')"
          @click="showPicker = birthdayShow ? false : true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-datetime-picker
            :title="$t('wdzl.date')"
            :confirm-button-text="$t('wdzl.confirm')"
            :cancel-button-text="$t('wdzl.cancel')"
            :min-date="minDate"
            :max-date="maxDate"
            type="date"
            @confirm="onDateConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          name="area"
          :value="form.country"
          style="
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
          "
          :label="$t('wdzl.dqxz')"
          :placeholder="$t('wdzl.djxzss')"
          @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-picker
            :title="$t('wdzl.dqxz')"
            :confirm-button-text="$t('wdzl.confirm')"
            :cancel-button-text="$t('wdzl.cancel')"
            show-toolbar
            :columns="areaList"
            value-key="nameCn"
            @confirm="onAreaConfirm"
            @cancel="showArea = false"
          />
        </van-popup>
      </van-form>
    </div>
    <div class="tips">{{ $t("wdzl.wxts") }}</div>
    <div class="btn" style="margin: 16px">
      <van-button round block type="info" @click="submit">{{
        $t("wdzl.qrtj")
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { users, accountsProfile, Countries } from "@/api/api.js";
import { Notify } from "vant";
import TopBar from "@/common/top-bar/index.vue";
import { mapState } from "vuex";

export default {
  name: "MyInfo",
  components: {
    TopBar,
  },
  data() {
    return {
      genderShow: false,
      birthdayShow: false,
      minDate: new Date(1903, 0, 1),
      maxDate: new Date(2020, 0, 1),
      form: {},
      showPicker: false,
      showArea: false,
      showSexPicker: false,
      columns: [
        { value: 1, label: this.$t("wdzl.boy") },
        { value: 2, label: this.$t("wdzl.girl") },
      ],
      areaList: [],
      avatarUrl: "",
      formNameDisabled: false,
    };
  },

  watch: {
    getAreaAndcountryId(val) {
      if (val) {
        val.areaList.forEach((element) => {
          if (element.id == val.country) {
            this.form.country = element.nameCn;
            this.form.countryCode = element.id;
          }
        });
      }
    },

    "$store.state.loginInfo": {
      handler(val) {
        this.$nextTick(() => {
          this.avatarUrl = val.avatarUrl + "";
        });
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState(["loginInfo"]),
    getAvatar() {
      return this.$store.state.loginInfo;
    },

    getAreaAndcountryId() {
      return { areaList: this.areaList, country: this.form.country };
    },
  },

  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onSubmit() {
      const params = {};
      accountsProfile(params).then((res) => {
        if (res.code === 200) {
        } else {
          let error = "";
          if (typeof res.errors == "string") {
            error = res.errors;
          } else {
            error = res.errors[0];
          }
          if (error.length > 0) {
            Notify({ type: "danger", message: error });
          }
        }
      });
    },

    onDateConfirm(value) {
      const dateSr = this.format(value);
      this.form.birthday = dateSr;
      this.showPicker = false;
    },

    onSexConfirm(value) {
      this.form.gender = value.label;
      this.form.genderCopy = value.value;
      this.showSexPicker = false;
    },
    format(dat) {
      //获取年月日，时间
      let year = dat.getFullYear();
      let mon =
        dat.getMonth() + 1 < 10
          ? "0" + (dat.getMonth() + 1)
          : dat.getMonth() + 1;
      let data = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
      let newDate = year + "-" + mon + "-" + data;
      return newDate;
    },

    onAreaConfirm(value) {
      this.form.country = value.nameCn;
      this.form.countryCode = Number(value.id);
      this.showArea = false;
    },

    submit() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const form = this.form;
      const params = {
        id: loginInfo.id,
        name: form.name,
        gender: form.genderCopy,
        birthday: form.birthday,
        country: form.countryCode,
        provinceID: form.provinceID,
        cityID: form.cityID,
        maritalStatusID: form.maritalStatusID,
        educationID: form.educationID,
        occupationStatusID: form.occupationStatusID,
        positionID: form.positionID,
        personalIncomeID: form.personalIncomeID,
        householdIncomeID: form.householdIncomeID,
        brandIDOfCar: form.brandIDOfCar,
        modelIDOfCar: form.modelIDOfCar,
        purchasedYearOfCar: form.purchasedYearOfCar,
        parnetsOfChilden: form.parnetsOfChilden,
        birthYearOfYoungChild: form.birthYearOfYoungChild,
      };
      accountsProfile(params).then((res) => {
        if (res.code === 200) {
          Notify({ type: "success", message: this.$t("updateInfoSuc") });
              this.initPage();
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    changeAvator() {
      this.$router.push("/updateAvatar");
    },

    initPage() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      users(params).then((res) => {
        //console.log(res);
        if (res.code === 200) {
          this.form = res.data;
          this.form.genderCopy = res.data.gender;
          this.genderShow = res.data.gender ? true : false;
          this.birthdayShow = res.data.birthday ? true : false;
          this.formNameDisabled = this.form.name ? true : false;
          if (res.data.gender == 1) {
            this.form.gender = this.$t("wdzl.boy");
          } else if (res.data.gender == 2) {
            this.form.gender = this.$t("wdzl.girl");
          } else {
            this.form.gender = "";
          }
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    getCountry() {
      Countries({}).then((res) => {
        if (res.code === 200) {
          this.areaList = res.data;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
  },
  mounted() {
    this.initPage();
    this.getCountry();
  },
  activated() {},
};
</script>

<style lang="stylus" scoped>
/deep/.my-info {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F3F3F3;

  .header {
  }

  .content {
    padding: 0.4rem;
    position: relative;

    .van-image__error-icon {
      font-size: 1rem;
    }

    .van-form:nth-child(1) {
      .van-cell:nth-child(1) {
        height: 1.5rem;

        .van-cell__title.van-field__label {
          display: flex;
          align-items: center;
        }
      }
    }

    .avator-sty {
      position: absolute;
      top: 0.6rem;
      right: 1.2rem;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
    }

    .icon-sty {
      position: absolute;
      top: 0.9rem;
      right: 0.1rem;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      color: #9F9C9C;
    }
  }

  .tips {
    padding: 0.4rem;
    line-height: 0.4rem;
    color: #C75353;
  }

  .btn {
    button {
      margin-top: 10vh;
      background: #FBC260;
      border: #FBC260;
      font-size: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myInfo/MyInfo.vue